import request, { post, get } from "@/utils/request";

// export function products(params) {
//     return request({
//       url: "/api/v1/products",  //接口路径
//       method: "get",  //接口方法
//       headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
//       params  //接口参数
//     });
// }

//-------------------------------登陆---------------------------------------
// 登陆
export const login = (params) => post("/login",params)
//登出
export const logout = () => get("/login/logout")
//用户注册
export const register = (params) => post("/login/register",params)
//获取用户菜单和权限
export const getMenuByUser = () => get("/menu/getMenuByUser")

//-------------------------------钉钉登录---------------------------------------
// 获取钉钉授权URL
export const getDingTalkAuthUrl = () => get("/dingtalk/auth-url")
// 轮询钉钉登录状态
export const pollDingTalkLogin = (params) => get("/dingtalk/poll", params)

export const dingTalkCallBack = (params) => get("/dingtalk/callback", params)

// 通用 SSO 免登
export const exchangeSsoToken = (params) => post("/sso/exchange", params)

//获取登陆用户信息
export const getUser = () => get("/user/getUserInfo")
//获取学校列表
export const getApeSchoolList = () => get("/school/getApeSchoolList")
//获取专业列表
export const getApeMajorList = () => get("/major/getApeMajorList")
//主页数据
export const getIndexAchievement = () => get("/index/getIndexAchievement")
//主页获取笔记
export const getIndexArticleList = () => get("/article/getIndexArticleList")
//分页获取课程
export const getApeTaskPage = (params) => post("/task/getApeTaskPage",params)
//获取分类列表
export const getApeClassificationList = (params = {}) => get("/classification/getApeClassificationList", {
  mark: params.mark ?? 1
})
//根据分类id获取标签列表
export const getApeTagByClassificationId = (params) => get("/tag/getApeTagByClassificationId", params)
//获取教师分页
export const getUserPage = (params) => post("/user/getUserPage",params)
//分页获取笔记
export const getApeArticlePage = (params) => post("/article/getApeArticlePage",params)
//分页获取公告
export const getAccountPage = (params) => post("/account/getAccountPage",params)
//分页获取留言
export const getApeMessagePage = (params) => post("/message/getApeMessagePage",params)
//保存留言
export const saveApeMessage = (params) => post("/message/saveApeMessage",params)
//获取个人信息
export const getUserInfo = () => get("/user/getUserInfo")
//保存个人信息
export const setUserInfo = (params) => post("/user/setUserInfo",params)
//保存头像
export const setUserAvatar = (params) => post("/user/setUserAvatar",params)
//修改密码
export const changePassword = (params) => post("/user/changePassword",params)
//获取课程信息
export const getApeTaskById = (params) => get("/task/getApeTaskById",params)
//保存课程报名
export const saveApeTaskStudent = (params) => post("/student/saveApeTaskStudent",params)
//获取用户报名情况
export const getTaskStudent = (params) => get("/student/getTaskStudent",params)
//根据课程id获取章节
export const getApeChapterByTaskId = (params) => get("/chapter/getApeChapterByTaskId",params)
//保存课程评论
export const saveApeTaskComment = (params) => post("/comment/saveApeTaskComment",params)
//获取课程评论
export const getApeTaskCommentListByTaskId = (params) => get("/comment/getApeTaskCommentListByTaskId",params)
//获取教师课程列表
export const getApeTaskByTeacher = (params) => get("/task/getApeTaskByTeacher",params)
//获取教师详情
export const getUserById = (params) => get("/user/getUserById",params)
//获取笔记详情
export const getApeArticleById = (params) => get("/article/getApeArticleById",params)
//保存笔记评论
export const saveApeArticleComment = (params) => post("/articleComment/saveApeArticleComment",params)
//获取笔记评论
export const getApeArticleCommentByArticleId = (params) => get("/articleComment/getApeArticleCommentByArticleId",params)
//查询笔记收藏
export const getApeArticleFavorPage = (params) => post("/favor/getApeArticleFavorPage",params)
//根据id查询笔记收藏
export const getApeArticleFavorById = (params) => get("/favor/getApeArticleFavorById",params)
//保存笔记收藏
export const saveApeArticleFavor = (params) => post("/favor/saveApeArticleFavor",params)
//更新笔记收藏
export const editApeArticleFavor = (params) => post("/favor/editApeArticleFavor",params)
//删除ApeArticleFavor
export const removeApeArticleFavor = (params) => post("/favor/removeApeArticleFavor",params)
//我的课程
export const getApeMyTaskPage = (params) => post("/student/getApeMyTaskPage",params)
//我的课程列表
export const getApeMyTaskList = (params) => post("/student/getApeMyTaskList",params)
//保存笔记
export const saveApeArticle = (params) => post("/article/saveApeArticle",params)
//上传图片
export const uploadImg = (params) => post("/common/uploadImg",params)
//新增笔记
export const insertApeArticle = (params) => post("/article/insertApeArticle",params)
//根据id获取章节
export const getApeChapterById = (params) => get("/chapter/getApeChapterById",params)
//查询学生作业
export const getApeHomeworkStudentPage = (params) => post("/student/getApeHomeworkStudentPage",params)
//根据id查询学生作业
export const getApeHomeworkStudentById = (params) => get("/student/getApeHomeworkStudentById",params)
//保存学生作业
export const saveApeHomeworkStudent = (params) => post("/student/saveApeHomeworkStudent",params)
//更新学生作业
export const editApeHomeworkStudent = (params) => post("/student/editApeHomeworkStudent",params)
//删除ApeHomeworkStudent
export const removeApeHomeworkStudent = (params) => get("/student/removeApeHomeworkStudent",params)
//获取作业题目
export const getApeHomeworkStudentList = (params) => post("/student/getApeHomeworkStudentList",params)
//获取章节作业数
export const getApeHomeworkByChapterId = (params) => get("/homework/getApeHomeworkByChapterId",params)
//获取作业完成标志
export const getApeHomeworkStudentFlag = (params) => get("/student/getApeHomeworkStudentFlag",params)
//获取我的作业
export const getMyApeHomework = (params) => get("/student/getMyApeHomework",params)
//获取错题
export const getWrongWork = (params) => get("/student/getWrongWork",params)
//保存章节视频是否观看
export const saveApeChapterVideo = (params) => post("/chapterVideo/saveApeChapterVideo",params)
//后去考试列表
export const getTestListByUser = (params) => get("/test/getTestListByUser",params)
//查询用户考试题目
export const getApeTestStudentPage = (params) => post("/student/getApeTestStudentPage",params)
//根据id查询用户考试题目
export const getApeTestStudentById = (params) => get("/student/getApeTestStudentById",params)
export const getApeTestResult = (params) => get("/student/getApeTestResult",params)
//更新用户考试题目
export const editApeTestStudent = (params) => post("/student/editApeTestStudent",params)
//删除ApeTestStudent
export const removeApeTestStudent = (params) => get("/student/removeApeTestStudent",params)
//获取考试题目
export const getApeTestItemByTestId = (params) => get("/item/getApeTestItemByTestId",params)
//保存考试内容
export const saveApeTestStudent = (params) => post("/student/saveApeTestStudent",params)
//获取考试状态
export const getTestUserState = (params) => get("/student/getTestUserState",params)
export const getTaskChapterStudy = (params) => get("/chapter/getTaskChapterStudy",params)

//-------------------------------论坛---------------------------------------
//查询论坛
export const getApeForumPage = (params) => post("/forum/getApeForumPage",params)
//根据id查询论坛
export const getApeForumById = (params) => get("/forum/getApeForumById",params)
//保存论坛
export const saveApeForum = (params) => post("/forum/saveApeForum",params)
//更新论坛
export const editApeForum = (params) => post("/forum/editApeForum",params)
//删除ApeForum
export const removeApeForum = (params) => get("/forum/removeApeForum",params)

//-------------------------------论坛讨论---------------------------------------
//查询论坛讨论
export const getApeForumItemPage = (params) => post("/item/getApeForumItemPage",params)
export const getApeForumItemList = (params) => post("/item/getApeForumItemList",params)
//根据id查询论坛讨论
export const getApeForumItemById = (params) => get("/item/getApeForumItemById",params)
//保存论坛讨论
export const saveApeForumItem = (params) => post("/item/saveApeForumItem",params)
//更新论坛讨论
export const editApeForumItem = (params) => post("/item/editApeForumItem",params)
//删除ApeForumItem
export const removeApeForumItem = (params) => get("/item/removeApeForumItem",params)

//-------------------------------答疑---------------------------------------
//查询答疑
export const getApeQuestionPage = (params) => post("/question/getApeQuestionPage",params)
//根据id查询答疑
export const getApeQuestionById = (params) => get("/question/getApeQuestionById",params)
//保存答疑
export const saveApeQuestion = (params) => post("/question/saveApeQuestion",params)
//更新答疑
export const editApeQuestion = (params) => post("/question/editApeQuestion",params)
//删除ApeQuestion
export const removeApeQuestion = (params) => get("/question/removeApeQuestion",params)

export const getApeTaskFavorById = (params) => get("/favor/getApeTaskFavorById",params)

export const removeApeTaskFavor = (params) => get("/favor/removeApeTaskFavor",params)

export const saveApeTaskFavor = (params) => post("/favor/saveApeTaskFavor",params)

export const getApeTaskFavorPage = (params) => post("/favor/getApeTaskFavorPage",params)

//-------------------------------视频---------------------------------------
// 获取轮播视频列表
export const getBannerList = () => get("/video/getBannerList")
// 获取最新视频列表
export const getLatestVideoList = (params) => get("/video/getLatestVideoList", params)
// 获取热门推荐视频列表
export const getPopularVideoList = (params) => get("/video/getPopularVideoList", params)
// 用户端分页查询视频列表
export const getVideoPage = (params) => post("/video/getVideoPage", params)
// 根据id获取视频详情
export const getVideoById = (params) => get("/video/getVideoById", params)
// 根据id获取视频活动详情（包含打卡要求信息）
export const getVideoActivityById = (params) => get("/activity/getVideoActivityByVideoId", params)
// 分页获取集中学习活动列表
export const getVideoActivityPage = (params) => post("/activity/getVideoActivityPage", params)
// 更新视频观看次数
export const updateVideoViewCount = (params) => post(`/video/updateViewCount?id=${params.id}`)
// 获取相关推荐视频列表
export const getRelatedVideoList = (params) => get("/video/getRelatedVideoList", params)
// 获取视频管理分页列表（用于笔记页面筛选）
export const getVideoManagePage = (params) => post("/manage/getVideoManagePage", params)
// 获取培训资料分页列表
export const getApeTrainingMaterialPage = (params) => post("/trainingMaterial/getApeTrainingMaterialPage", params)
// 获取培训资料详情
export const getApeTrainingMaterialById = (params) => get("/trainingMaterial/getApeTrainingMaterialById", params)
// 记录培训资料查阅次数
export const recordApeTrainingMaterialView = (params) => post("/trainingMaterial/recordApeTrainingMaterialView", params)
// 获取我的培训计划列表
export const getMyTrainingPlanList = () => get("/trainingPlan/getMyTrainingPlanList")
// 获取我的培训计划详情
export const getMyTrainingPlanDetail = (params) => get("/trainingPlan/getMyTrainingPlanDetail", params)
// 标记培训资料完成
export const completeTrainingMaterial = (params) => post("/trainingPlan/completeTrainingMaterial", params)
// 获取培训资料学习进度映射视频ID
export const getTrainingMaterialSyncVideoId = (params) => get("/trainingPlan/getTrainingMaterialSyncVideoId", params)
// 保存培训资料视频学习进度
export const saveTrainingMaterialVideoProgress = (params) => post(
  "/trainingPlan/saveTrainingMaterialVideoProgress",
  params,
  { suppressErrorAlert: true }
)
// 分页获取我的通知消息
export const getMyUserNoticePage = (params) => post("/userNotice/getMyUserNoticePage", params)
// 获取我的未读通知数量
export const getMyUnreadNoticeCount = () => get("/userNotice/getMyUnreadNoticeCount")
// 标记单条通知已读
export const readUserNotice = (params) => post("/userNotice/readUserNotice", params)
// 一键已读全部通知
export const readAllUserNotice = () => post("/userNotice/readAllUserNotice", {})
// 获取笔记列表
export const getNoteList = (params) => post("/article/getNoteList", params)

//-------------------------------用户学习数据---------------------------------------
// 获取用户月度打卡数据
export const getMonthlyCheckin = (params) => get("/study/getMonthlyCheckin", params)
// 获取用户累计学习统计数据
export const getUserStudyStats = (params) => get("/study/getUserStudyStats", params)
// 获取学习数据看板
export const getStudyDashboard = (params) => get("/study/getStudyDashboard", params)
// 分页获取观看记录
export const getWatchRecordPage = (params) => post("/study/getWatchRecordPage", params)
// 获取每日学习详情
export const getDailyStudyDetail = (params) => get("/study/getDailyStudyDetail", params)

//-------------------------------打卡记录---------------------------------------
// 获取打卡统计信息
export const getClockStatistics = (params) => get("/clock/statistics", params)
// 获取打卡记录列表
export const getClockRecordList = (params) => post("/clock/records/list", params)
// 获取集中学习打卡记录列表
export const getConcentratedClockRecordList = (params) => post("/article/getConcentratedClockRecord", params)
// 获取本月总打卡天数（包括视频学习和集中学习）
export const getUnifiedMonthlyClockDays = (params) => get("/study/getUnifiedMonthlyClockDays", params)
// 获取指定月份统一打卡数据（包括视频学习和集中学习）
export const getUnifiedMonthlyCheckin = (params) => get("/study/getUnifiedMonthlyCheckin", params)

//-------------------------------视频播放进度---------------------------------------
// 获取用户视频播放进度
export const getUserVideoProgress = (params) => get(
  "/study/getUserVideoProgress",
  params,
  { suppressErrorAlert: true }
)
// 保存视频播放进度
export const saveVideoProgress = (params) => post(
  "/study/saveVideoProgress",
  params,
  { suppressErrorAlert: true }
)

//-------------------------------文件上传---------------------------------------
// 上传文件
export const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/common/uploadFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

//-------------------------------视频完成统计---------------------------------------
// 获取视频完成人数
export const getCompletedCountByVideoId = (params) => get('/study/getCompletedCountByVideoId', params)

//-------------------------------笔记管理---------------------------------------
// 编辑笔记
export const editUserStudyDetail = (params) => post('/article/editApeArticle', params)
// 删除笔记
export const removeUserStudyDetail = (params) => get('/article/removeApeArticle', params)
